export const ADD_MEMBER_UPLOAD = 'add-member-upload';
export const IMPORT_FILE_GERMAN = 'import-file-german';
export const JOIN_CLUB = 'join-club';
export const SESSION_DUPLICATE_MODAL = 'session-duplicate-modal';
export const SESSION_IMPORT_DATA = 'add-import-data';
export const SESSION_INFO_MODAL = 'session-info-modal';
export const SESSION_IMPORT_FILE_LIST_ITEM_INFO_MODAL = 'session-import-file-list-item-info-modal';
export const SESSION_IMPORT_FILE_CHANGE_SPORT_MODAL = 'session-import-file-change-sport-modal';
export const SHARE_CALENDAR_LINK = 'calendar-share-link-modal';
export const ASSIGN_MEMBERS = 'calendar-assign-members';
export const REMOVE_MEMBERS = 'calendar-remove-members';
export const ADD_SESSION_RESULTS = 'add-session-results';
export const CREATE_MORNING_MONITORING = 'create-morning-monitoring';
export const ADD_NOTE = 'add-note';
export const CREATE_SESSION_FURTHER_ACTIONS = 'create-session-further-actions';
export const CREATE_SESSION_LOCATION_MODAL = 'create-session-location-modal';
export const CREWS_ASSIGN_TO_SESSIONS = 'crews:assign-to-sessions';
export const CALENDAR_HEAT_MAP_MONTH = 'calendar-heat-map-month';
export const ASSIGN_EQUIPMENT = 'assign-equipment';
export const MERGE_SESSIONS = 'calendar-merge-sessions';
export const ADD_EDIT_EFFORT = 'add-edit-effort';
export const FAVOURITE_VIEW = 'favourite-view-modal';
export const MINIMAX_EDIT_WEATHER_CONDITION = 'minimax:edit-weather-condition';
export const MINIMAX_EDIT_NOTE = 'minimax:edit-note';
export const MINIMAX_MAP = 'minimax:map';
export const MINIMAX_GRAPHS_CONFIG = 'minimax:graphs-config';
export const GOOGLE_MAP_MODAL = 'google-map';
export const GROUP_CHAT = 'group-chat';
export const ADMIN_CREATE_USER_FURTHER_ACTIONS = 'admin:create-user:further-actions';
export const QR_CONNECTIONS = 'qr-connection';
